<template>
  <footer
    id="main-footer"
    class="bg-float-default-low text-static-default-hi relative p-32"
  >
    <div class="mx-auto w-full lg:max-w-[1120px]">
      <FooterEmailCollector v-if="FF_ENABLE_FOOTER_EMAIL_COLLECTOR" />

      <div class="flex list-none flex-col gap-32 md:flex-row">
        <nav
          v-for="(column, index) in columns"
          :key="index"
          :aria-label="column.title ? i18n(column.title) : undefined"
          class="md:basis-full"
        >
          <FooterLinkColumn :links="column.links" :title="column.title">
            <FooterSocialIcons
              v-if="column.socials?.length"
              :socials="column.socials"
            />

            <PaymentIcons
              v-if="
                column.links.some(
                  (link) => link.label.id === 'footer_payment_methods',
                )
              "
              class="pt-6"
            />

            <FooterLogos v-if="column.logos?.length" :logos="column.logos" />
          </FooterLinkColumn>
        </nav>
      </div>

      <RevDivider class="my-20" />

      <FooterBottomBar />
    </div>
  </footer>
</template>

<script setup lang="ts">
import { useRuntimeConfig } from '#imports'

import PaymentIcons from '@backmarket/nuxt-layer-payment/methods/PaymentIcons'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDivider } from '@ds/components/Divider'

import FooterEmailCollector from '~/scopes/navigation/components/Footer/FooterEmailCollector/FooterEmailCollector.vue'

import { useFooterConfig } from '../composables/useFooterConfig'

import FooterBottomBar from './FooterBottomBar.vue'
import FooterLinkColumn from './FooterLinkColumn.vue'
import FooterLogos from './FooterLogos.vue'
import FooterSocialIcons from './FooterSocialIcons.vue'

const { FF_ENABLE_FOOTER_EMAIL_COLLECTOR = false } = useRuntimeConfig().public
const i18n = useI18n()

const { columns } = useFooterConfig()
</script>
